import { render, staticRenderFns } from "./UploadSupportingDocuments.vue?vue&type=template&id=c528d742&scoped=true&"
import script from "./UploadSupportingDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadSupportingDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UploadSupportingDocuments.vue?vue&type=style&index=0&id=c528d742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c528d742",
  null
  
)

export default component.exports